<template>
    <div class="user">
        <div class="user_hea">
            <myHeaderW></myHeaderW>
        </div>
        <div class="user_ban">
            <img :src="$httpImg +'/img/bag/cooperation.png'" />
            <div class="user_ban_center">
                <img :src="$httpImg +'/img/bag/user1.png'" />
                <div class="user_ban_center_title">
                    <h4 id="user0">超拼网简介</h4>
                    <span></span>
                </div>
                <div class="user_ban_center_html" v-html="data.intro">

                </div>
            </div>

        </div>
        <div class="user_culture">
            <h5>企业文化</h5>
            <div class="user_culture_cen">
                <img class="bg" :src="$httpImg +'/img/bag/user2.png'" />
                <div class="user_culture_cen_left">

                    <h6>核心价值观</h6>
                    <p>和源头药厂，源头厂家合作， 去除中间商，专注严选好货， 从源头到消费者餐桌。</p>
                </div>
                <img :src="$httpImg +'/img/user/cultrue.png'" />
            </div>
        </div>
        <div class="user_banner">
            <h5 id="user1">领导团队</h5>
            <div class="user_banner_cen">
                <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="item in data.team" :key="item">
                        <div class="banner_item">
                            <img :src="item.url" />
                            <div class="user_banner_left">
                                <div class="user_banner_left_t">
                                    <h2>{{ item.name }}</h2>
                                    <p>{{ item.description }}</p>
                                    <span></span>
                                </div>
                                <div class="user_banner_left_b">
                                    {{ item.remake }}
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="user_develop">
            <h5 id="user2">发展大事记</h5>
           
            <div class="user_develop_cen">
                <div class="user_develop_top">
                    <div class="user_develop_top_cen">
                        <!-- <div class="le">1</div> -->
                        <div class="user_develop_year">
                            <div v-for="(i,index) in data.development" :key="i" style="display: flex;flex-direction: column;align-items: center;">
                                <span :class="data.span_active==index?'span_active':''" @click="setspanactive(index,i)"></span>
                                <p :class="data.span_active==index?'p_active':''">{{ i.year }}</p>
                            </div>
                        </div>
                        <!-- <div class="ri">2</div> -->
                    </div>
                    <div></div>
                </div>
               
                <div class="user_develop_Stepbar">
                    <h4 style="margin-bottom: 30px;">{{data.year}}年大事记</h4>
                    <el-timeline style="max-width: 600px">
                        <el-timeline-item v-for="(activity, index) in data.activities" :key="index" 
                            type="primary" color="#30C9C4" size="large"
                             :timestamp="activity.month+'月'">
                             <div v-html=" activity.content "></div>
                         
                        </el-timeline-item>
                    </el-timeline>
                </div>

            </div>
        </div>
        <div class="user_honor">
            <h5 id="user3">获得荣誉</h5>

            <div class="user_banner_cen">
                <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="item in data.hoorData" :key="item">
                        <div class="banner_item">
                            <div class="banner_li" v-for="i in item.list" :key="i">
                                <img :src="i.url" />
                                <p>{{ i.name }}</p>
                            </div>

                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <myFooter></myFooter>

    </div>
</template>

<script>
import { reactive, ref, toRefs, } from "@vue/reactivity";
import { onMounted } from "vue";
import myHeaderW from '@/components/myHeaderW.vue'
import myFooter from '@/components/myFooter.vue'
import { getconfig, getbanner,developmentCourse } from '@/comm/api'

export default {
    components: {
        myHeaderW,
        myFooter
    },
    setup() {
        const activeName = ref('0')
        let data = reactive({
            dataSce: [
            ],
            team: [],
            intro: "",
            hoorData: [],
            development:[],
            year:2006,
            span_active:0,
            developmentactive:{},
            activities:[]

        });

        // const activities = [
        //     {
        //         content: '超拼网1.0版本研发正式启动。     ',
        //         timestamp: '1月',
        //         size: 'large',
        //         type: 'primary',
        //         color: '#0bbd87',
        //     },
        //     {
        //         content: ' 超拼网内测版本上线。',
        //         timestamp: '4月',
        //         color: '#0bbd87',
        //     },
        //     {
        //         content: '超拼网1.0版本正式上线，2.0版本研发启动。',
        //         timestamp: '7月',
        //         color: '#0bbd87'
        //     },
        //     {
        //         content: '超拼网助力陕西周至',
        //         timestamp: '12月',
        //         color: '#0bbd87',

        //     },
        // ]

        const handleClick = (tab, event) => {
            console.log(tab, event)
        }

        const getconfigFn = async (configName,) => {
            try {
                const res = await getconfig({ configName: configName });
                if (res.code == 1) {
                    data[configName] = res.data
                }

            } catch (err) {
                console.error("失败", err);

            }
        };
        const getdevelopmentCourse = async (configName,) => {
            try {
                const res = await developmentCourse({ configName: configName });
 
                if (res.code == 1) {
                    res.data.map((i,index)=>{
                        if(index==0){
                            i.chi = []
                            data.development.push(i) 
                        }
                        if( index!=0 && i.year !=res.data[index-1].year ){
                            i.chi = []
                            data.development.push(i)
                        }else{
                            data.development.map(item=>{
                                if(item.year==i.year){
                                    item.chi.push(i)
                                }
                            }) 
                        }

                    })
                    data.activities=data.development[0].chi
                    data.year=data.development[0].year
                    console.log("data.development", data.development);
                }

            } catch (err) {
                console.error("失败", err);

            }
        };
        
        const getbannerList = async (type) => {

            try {
                const res = await getbanner({ type: type });
                if (res.code == 1) {
                    if (res.data.length > 0 && type == 2) {
                        let cer = 0
                        let index = Math.ceil(res.data.length / 6)
                        for (var i = 0; i < index; i++) {


                            if (cer == res.data.length) {
                                let item = {
                                    list: res.data.slice(cer, res.data.length)
                                }
                                data.hoorData.push(item)
                            } else if (cer < res.data.length) {
                                let item = {
                                    list: res.data.slice(cer, cer + 6)
                                }
                                cer = cer + 6 + 1
                                data.hoorData.push(item)
                            }

                        }
                    } else {
                        data.team = res.data
                    }

                }
            } catch (err) {
                console.error("失败", err);

            }
        };
        const setspanactive = (index,i) =>{
              data.span_active = index
              data.activities = i.chi
              console.log( i.chi,' i.chi i.chi i.chi i.chi')
              data.year=i.year
        }
        onMounted(() => {
            getconfigFn('intro')
            getdevelopmentCourse()
            getbannerList(2)
            getbannerList(5)
        })
        return {
            data,
            activeName,
            handleClick,

            getconfigFn,
            setspanactive,
            getdevelopmentCourse
        }
    }
}
</script>

<style lang="scss" scoped>
.user {
    background: #fff;
}

:deep(.el-timeline-item__timestamp.is-bottom) {
    position: absolute;
    left: -50px;
    top: -5px;
}
:deep(.el-timeline-item) {
    padding-bottom: 40px;
}

.user_develop_top {
    width: 100%;
    border-bottom: 1px solid #AAAAAA;
    // margin-top: 60px;
    margin-bottom: 60px;

    .user_develop_top_cen {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        transform: translatey(50%);

        .le {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            border: 1px solid #AAAAAA;
            text-align: center;
            line-height: 45px;
            background: #fff;
        }

        .ri {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            border: 1px solid #AAAAAA;
            text-align: center;
            line-height: 45px;
            background: #fff;
        }

        .user_develop_year {
            width: 80%;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            transform: translatey(43%);
            cursor: pointer;

            span {
                display: block;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                border: 1px solid #AAAAAA;
                background: #fff;
            }
            .span_active{
                background: #82DCD9;
            }
            .p_active{
                color: #82DCD9;
            }
            p {
                text-align: center;
                font-family: HONOR Sans CN;
                font-weight: 500;
                font-size: 20px;
                color: #000000;
                margin-top: 40px;
            }
        }


    }
}

.user_develop_Stepbar {
    width: 800px;
    margin: 0 auto;
    margin-top: 128px;

    h4 {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 20px;
        color: #010101;
        line-height: 30px;
    }

    .vertical {
        height: 400px;
        border-left: 1px solid #D2D2D2;
        display: flex;
        flex-direction: column;


        span {
            width: 7px;
            height: 7px;
            background: #D2D2D2;
            border-radius: 50%;
            transform: translatex(-50%);
            margin-top: 30px;
        }
    }
}

.vertical_Stepbar {
    display: flex;
}

.user_hea {
    width: 100%;
    background: #fff;

}

.user_ban {
    position: relative;

    img {
        position: relative;
        width: 100%;
    }

    .user_ban_center {
        position: absolute;
        width: 1200px;
        height: 250px;
        background: #FFFFFF;
        box-shadow: 0px 2px 29px 0px rgba(33, 22, 19, 0.1);
        border-radius: 10px;
        left: 50%;
        padding: 50px;
        transform: translate(-50%, -50%);

        img {
            width: 70px;
            position: absolute;
            right: 0px;
            top: 0px;
        }

        h4 {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            text-align: center;
        }

        span {
            display: block;
            width: 42px;
            height: 4px;
            background: #82DCD9;
            margin: 10px auto;
        }

        .user_ban_center_html {
            margin-top: 40px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #747474;
            line-height: 30px;

            p {
                text-indent: 2em;
            }
        }
    }

}

.user_culture {
    height: 550px;
    background: #FBFBFB;
    padding-top: 300px;

    h5 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        text-align: center;
    }

    .user_culture_cen {
        width: 1200px;
        margin: 20px auto;
        position: relative;
        display: flex;
        border-radius: 20px;
        z-index: 999;

        .bg {
            position: absolute;
            z-index: 0;
            left: 0px;
            top: 0px;
            transform: translate(-40%, -30%);
            z-index: 0;
        }

        .user_culture_cen_left {
            width: 40%;
            background: #fff;
            padding: 10%;
            border-radius: 20px;
            position: relative;
            z-index: 2;

            h6 {
                font-family: HONOR Sans CN;
                font-weight: 500;
                font-size: 20px;
                color: #000000;
                margin-bottom: 40px;
            }

            p {
                width: 220px;
                line-height: 30px;
            }
        }

    }
}

.user_banner {
    background: #fff;
    padding: 40px;

    h5 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        text-align: center;
        padding: 40px;
    }

    .user_banner_cen {
        width: 1200px;
        height: 600px;
        margin: 0 auto;

        .banner_item {
            height: 500px;
            background: url('../../assets/img/ban_y.png') no-repeat;
            background-size: 100% 100%;
            position: relative;

            img {
                margin-left: 150px;
            }

            .user_banner_left {
                position: absolute;
                right: 0px;
                top: 100px;
                z-index: 2;
                width: 50%;
                height: 300px;

                .user_banner_left_t {
                    h2 {
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #000000;
                        margin-top: 20px;
                    }

                    p {
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        margin-top: 15px;
                    }

                    span {
                        display: block;
                        width: 26px;
                        height: 4px;
                        background: #82DCD9;
                        margin-top: 20px;
                    }
                }

                .user_banner_left_b {
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #747474;
                    line-height: 30px;
                    margin-top: 40px;
                }


            }
        }
    }
}

.user_develop {
    background: url('../../assets/img/bag/user3.png') no-repeat;
    background-size: 100% 100%;
    // height: 700px;

    h5 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        text-align: center;
        padding: 0px;
    }
}

.user_honor {
    background: #fff;
    background-size: 100% 100%;
    height: 700px;

    h5 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        text-align: center;
        padding: 40px;
    }

    .user_banner_cen {
        width: 1200px;
        margin: 0 auto;

        .banner_item {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-around;

            .banner_li {
                margin: 20px;
                height: 200px;

                img {
                    height: 200px;
                }

                p {
                    text-align: center;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                }
            }
        }
    }
}

:deep(.el-carousel__container) {
    height: 500px;
}

:deep(.el-carousel__indicator.el-carousel__indicator--horizontal.is-active) {
    color: #82DCD9;
}
</style>